const ContactIcon = ({ className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M2.39321 12.2479C2.29368 12.1793 2.20108 12.1023 2.11436 12.0155C1.33331 11.2345 1.33331 9.9774 1.33331 7.46325C1.33331 4.94909 1.33331 3.69201 2.11436 2.91096C2.89541 2.12991 4.15249 2.12991 6.66665 2.12991H9.33331C11.8475 2.12991 13.1045 2.12991 13.8856 2.91096C14.6666 3.69201 14.6666 4.94909 14.6666 7.46325C14.6666 9.9774 14.6666 11.2345 13.8856 12.0155C13.7989 12.1023 13.7063 12.1793 13.6068 12.2479"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M5.79084 11.4139C5.21446 11.7649 3.7032 12.4816 4.62366 13.3785C5.07329 13.8166 5.57407 14.1299 6.20367 14.1299H9.79629C10.4259 14.1299 10.9267 13.8166 11.3763 13.3785C12.2968 12.4816 10.7855 11.7649 10.2091 11.4139C8.8575 10.5908 7.14246 10.5908 5.79084 11.4139Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66665 7.46324C9.66665 8.38371 8.92045 9.1299 7.99998 9.1299C7.07951 9.1299 6.33331 8.38371 6.33331 7.46324C6.33331 6.54276 7.07951 5.79657 7.99998 5.79657C8.92045 5.79657 9.66665 6.54276 9.66665 7.46324Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export default ContactIcon;
